class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.productId = parsedState && parsedState.id;

    const sections = parsedState && parsedState.sections;
    let drawerSectionHtml = sections && sections['cart-drawer'];
    if (!drawerSectionHtml && sections) {
      const dynamicKey = Object.keys(sections).find(
        (k) => k === 'cart-drawer' || k.endsWith('__cart-drawer') || (k.includes('cart-drawer') && !k.includes('icon'))
      );
      if (dynamicKey) drawerSectionHtml = sections[dynamicKey];
    }

    const applyFromSectionHtml = (sectionHtml) => {
      if (!sectionHtml) return false;
      const innerFrag = this.getSectionInnerHTML(sectionHtml, '#CartDrawer');
      if (innerFrag) {
        const mount = this.querySelector('#CartDrawer');
        if (mount) mount.innerHTML = innerFrag;
        return true;
      }
      const sourceInnerNode = new DOMParser()
        .parseFromString(sectionHtml, 'text/html')
        .querySelector('#CartDrawer .drawer__inner');
      const liveInner = this.querySelector('#CartDrawer .drawer__inner');
      if (sourceInnerNode && liveInner) {
        liveInner.replaceWith(sourceInnerNode);
        return true;
      }
      return false;
    };

    if (drawerSectionHtml && applyFromSectionHtml(drawerSectionHtml)) {
      this.classList.toggle('is-empty', !this.querySelector('#CartDrawer .cart-item'));
    } else if (typeof routes !== 'undefined' && routes.cart_url) {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((r) => r.text())
        .then((text) => {
          if (applyFromSectionHtml(text)) {
            this.classList.toggle('is-empty', !this.querySelector('#CartDrawer .cart-item'));
          }
        })
        .catch(() => {});
    }

    if (sections) {
      let bubbleHtml = sections['cart-icon-bubble'];
      if (bubbleHtml == null) {
        const bubbleKey = Object.keys(sections).find((k) => k.includes('cart-icon-bubble'));
        if (bubbleKey) bubbleHtml = sections[bubbleKey];
      }
      if (bubbleHtml) {
        const bubbleLink = document.getElementById('cart-icon-bubble');
        if (bubbleLink) {
          const inner = this.getSectionInnerHTML(bubbleHtml, '.shopify-section');
          if (inner !== '') bubbleLink.innerHTML = inner;
        }
      }
    }

    setTimeout(() => {
      const ov = this.querySelector('#CartDrawer-Overlay');
      if (ov) ov.addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (html == null) {
      return '';
    }
    const node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return node ? node.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
